import { l10nEnService } from '@uplift/services';

export const useSexOptions = (l10n: typeof l10nEnService) => {
  const sexOptions = [
    {
      value: 'female',
      label: l10n.sex.female,
    },
    {
      value: 'male',
      label: l10n.sex.male,
    },
  ];

  return {
    sexOptions,
  };
};
